export default __webpack_public_path__ + "static/media/P200_Tip_Box.53bbbedd.svg";